"use client";

import Cookies from "js-cookie";
import { useState, useEffect } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { useAppSelector } from "@/services/hooks/redux.hooks";

export function FeatureModal({ modalConfig }: { modalConfig: any }) {
  const { language } = useAppSelector((state) => state.user);
  const { completed_onboarding } = useAppSelector((state) => state.user);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    if (modalConfig?.cookieName) {
      const isClosedBefore =
        Cookies.get(modalConfig.cookieName) || !completed_onboarding?.length;

      if (isClosedBefore) setIsOpen(false);
      else setIsOpen(true);
    }
  }, [completed_onboarding?.length, modalConfig]);

  const handleClose = () => {
    setIsOpen(false);
    const currentDate = new Date();
    currentDate.setFullYear(currentDate.getFullYear() + 1);
    Cookies.set(modalConfig.cookieName, "true", {
      expires: currentDate,
    });
  };

  if (
    !isOpen ||
    modalConfig?.title == null ||
    !modalConfig?.is_active ||
    language === "" ||
    completed_onboarding?.length
  )
    return null;

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          handleClose();
        }
      }}
    >
      <DialogContent className="lg:max-w-2xl max-w-xl flex flex-col">
        <DialogHeader className="max-h-fit md:mt-0 mt-2">
          <DialogTitle>{modalConfig?.title?.[language] ?? ""}</DialogTitle>
          <DialogDescription>
            {modalConfig?.description?.[language] ?? ""}
          </DialogDescription>
        </DialogHeader>
        <div className="md:py-4 py-2 flex-1 overflow-auto md:max-h-[50vh] max-h-[80vh]">
          <ul className="list-disc pl-4 space-y-2">
            <ul className="space-y-4">
              {Object.entries(modalConfig?.list?.[language])?.map(
                ([header, items]: any, index) => (
                  <li key={index}>
                    <strong>{header}</strong>
                    <ul className="list-disc pl-4 space-y-2">
                      {items.map((item: string, idx: number) => (
                        <li key={idx}>{item}</li>
                      ))}
                    </ul>
                  </li>
                ),
              ) ?? ""}
            </ul>
          </ul>
        </div>
        <DialogFooter className="h-fit">
          <Button onClick={handleClose}>
            {modalConfig?.button_title?.[language] ?? "Got it, thanks!"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
